/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('click', function(event) {
    if (event.target.closest('.Cart__Checkout.Button')) {
        event.preventDefault(); 
        window.location.href = '/checkout';
    }
});

$(function () {

  $(".toggle_filter").click(function () {
    $("#collection-filter-drawer").attr("aria-hidden", function (i, attr) {
      return attr == "true" ? "false" : "true";
    });
  });

  $("#collection-filter-drawer .Drawer__Close").click(function () {
    $("#collection-filter-drawer").attr("aria-hidden", function (i, attr) {
      return attr == "true" ? "false" : "true";
    });
  });

  $(".toggle_model_view").click(function () {
    console.log('clicked');
    $(".toggle_model_view").toggleClass("active");
    $(".collection__main").toggleClass("model-view");
  });

  $(".more_tags_taggle").click(function () {
    $(".more_tags_taggle").attr("aria-expanded", function (i, attr) {
      return attr == "true" ? "false" : "true";
    });
    $(".more_tags").toggleClass("active");
  });

  /* category filter */

  $(".category_filter li a").each(function(i,item){
    var windowUrl = window.location.href;
    var questionMarkIndex = windowUrl.indexOf('?');
    if(questionMarkIndex != -1){
    var parameterString = windowUrl.substring(questionMarkIndex);
    $(item).attr("href",$(item).attr("href")+parameterString);
       $(".clear_filter").addClass("active");
    }else{
       $(".clear_filter").removeClass("active");
    }
  });


  
  /* category filter */
  
});


